module.exports = __webpack_public_path__ + "media/hero_5.a7539176.mp4";